jQuery( $ => {

    $( '.content-columns > div > h2' ).on('click', e => e.currentTarget.classList.toggle('open') );

    // close dropdowns when screen is bigger than mobile
    $(window).on( 'resize', () => {
        if( false == $.isMobile() ){
            let open = document.querySelectorAll('.content-columns > div > h2.open');
            if(open){
                Array.from(open).forEach( el => el.classList.remove('open') );
            }
        }
    })

});